import React, { useRef, useEffect, useState } from "react";
import lottie, { AnimationItem } from "lottie-web";
import balloons from "./balloons.json";
import * as S from "./styles";

interface Props {
  visible: boolean;
  onClose: () => void;
}

const BirthdayAnimation: React.FC<Props> = ({ visible, onClose }) => {
  const containerRef1 = useRef<HTMLDivElement>(null);
  const containerRef2 = useRef<HTMLDivElement>(null);
  const containerRef3 = useRef<HTMLDivElement>(null);
  const containerRef4 = useRef<HTMLDivElement>(null);
  const containerRef5 = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(visible);

  useEffect(() => {
    setIsVisible(visible);
  }, [visible]);

  useEffect(() => {
    const animations: (AnimationItem | null)[] = [];

    if (isVisible) {
      const refs = [
        containerRef1.current,
        containerRef2.current,
        containerRef3.current,
        containerRef4.current,
        containerRef5.current,
      ];

      refs.forEach((ref) => {
        if (ref) {
          const anim = lottie.loadAnimation({
            container: ref,
            renderer: "svg",
            loop: true,
            autoplay: true,
            animationData: balloons,
          });
          animations.push(anim);
        }
      });
    }

    return () => {
      animations.forEach((anim) => {
        if (anim) {
          anim.destroy();
        }
      });
    };
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <S.AnimationWrapper>
      <S.Container ref={containerRef1} style={{ left: "0%" }} />
      <S.Container ref={containerRef2} style={{ left: "20%" }} />
      <S.Container ref={containerRef3} style={{ left: "40%" }} />
      <S.Container ref={containerRef4} style={{ left: "60%" }} />
      <S.Container ref={containerRef5} style={{ left: "80%" }} />
    </S.AnimationWrapper>
  );
};

export default BirthdayAnimation;
